module.exports = __webpack_public_path__ + "static/media/kick-that-habit-man.ae56fddd.jpg";